import { inject } from 'vue'
import { useStore } from 'vuex'

export function useTCE() {
  const vuexStore = useStore()
  const trackCustomEvent = inject('trackCustomEvent')
  const tce = (evenName, params, adapters) => {
    trackCustomEvent.call({ $store: vuexStore }, evenName, params, adapters)
  }
  return tce
}
